<template>
  <div class="wg-row">
    <!-- Select sorting modal -->
    <wg-modal
      :width="windowWidth > 700 ? '300px' : '80%'"
      v-if="sortingModalStatus"
      @closeModal="closeSortingModal()"
    >
      <div
        class="wg-row"
        slot="header"
        style="flex-wrap: nowrap; align-items: center"
      >
        <div class="com-anm22-app-text-xl" slot="header">
          {{ $anm22.strLang(lang, "Order", "Ordinamento") }}
        </div>
      </div>
      <div slot="body">
        <div class="wg-row">
          <div class="com-anm22-app-text-xl">{{ $anm22.strLang(lang, 'Field', 'Proprietà') }}</div>
        </div>
        <div class="vertical-height-div" style="height: 10px"></div>
        <div
          class="wg-row cont"
          style="align-items:center;flex-wrap:nowrap;margin-bottom:10px;position:relative;"
          v-for="(f,index) in orderingContactsFields"
          @click="changeSortingField(f.field)"
          :key="'field-contact'+index"
        >
          <div :style="{fontSize:'15px',marginLeft:'8px'}">{{ f.label }}</div>
          <div class="cont-tick" v-if="orderingContactsField == f.field">
            <img style="width:20px;" :src="$anm22.icons.getWorldIcon('tick')" />
          </div>
        </div>
        <div class="wg-row">
          <div class="com-anm22-app-text-xl">{{ $anm22.strLang(lang, 'Direction', 'Direzione') }}</div>
        </div>
        <div class="vertical-height-div" style="height: 10px"></div>
        <div
          class="wg-row cont"
          style="align-items:center;flex-wrap:nowrap;margin-bottom:10px;position:relative;"
          @click="changeSortingDir('ASC')"
        >
          <div :style="{fontSize:'15px',marginLeft:'8px'}">{{ $anm22.strLang(lang, 'Increasing', 'Crescente') }}</div>
          <div class="cont-tick" v-if="orderingContactsDir === 'ASC'">
            <img style="width:20px;" :src="$anm22.icons.getWorldIcon('tick')" />
          </div>
        </div>
        <div
          class="wg-row cont"
          style="align-items:center;flex-wrap:nowrap;margin-bottom:10px;position:relative;"
          @click="changeSortingDir('DESC')"
        >
          <div :style="{fontSize:'15px',marginLeft:'8px'}">{{ $anm22.strLang(lang, 'Decreasing', 'Decrescente') }}</div>
          <div class="cont-tick" v-if="orderingContactsDir === 'DESC'">
            <img style="width:20px;" :src="$anm22.icons.getWorldIcon('tick')" />
          </div>
        </div>
      </div>
    </wg-modal>
    <div
      id="contacts-list-col"
      class="wg-col wg-xs-12"
    >
      <div
        id="contacts-bar"
        class="wg-row contacts-bar"
        style="flex-wrap:nowrap;justify-content:space-between;"
      >
        <div class="display-flex" style="flex-wrap:nowrap;gap:5px;">
          <img
            @click="openSortingModal()"
            class="sort-modal"
            :src="$anm22.icons.getWorldIcon('sort')"
          />
          <img
            v-if="workSelected == 965"
            @click="filterNoProjects"
            class="sort-modal"
            :title="$anm22.strLang(lang, 'Filter without projects', 'Filtra senza progetto')"
            :src="$anm22.icons.getTasksIcon('tasksBlack')"
          />
        </div>
        <input
          type="button"
          class="small"
          :value="'+ ' + $anm22.strLang(lang, 'New contact', 'Nuovo contatto')"
          @click="openNewContactModal()"
        />
        <img
          @click="$emit('openModalViews')"
          class="change-view"
          :src="$anm22.icons.getWorldIcon('viewFull')"
        />
      </div>
      <div
        id="contacts-div"
        class="contacts-list com-anm22-app-scrolling-panel"
      >
        <div
          v-if="filters.length > 0"
          class="wg-row item"
          style="
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          "
        >
          <div
            v-for="(filter, index) in filters"
            :key="'filter-' + index"
            class="display-flex filter-button"
            @click="$emit('remove-filter', index)"
          >
            <img
              class="com-anm22-app-img-fixed-height-s"
              :src="$anm22.icons.getWorldIcon('deleteBlack')"
              style="margin-right: 10px"
            />
            <div class="com-anm22-app-text-m">{{ filter.name }}</div>
          </div>
        </div>
        <div
          v-if="loading"
          class="wg-row"
          style="margin: 10px; justify-content: center"
        >
          <vue-simple-spinner size="medium" line-fg-color="#0aabf4" />
        </div>
        <div v-else>
          <div v-if="workSelected !== 'my'" class="wg-row list-owner">
            <img
              :src="
                $anm22.getObjIcon(
                  $store.getters['works/get'](workSelected),
                  'workDefault'
                )
              "
              class="image"
            />
            <div class="name">
              {{ $store.getters["works/get"](workSelected).name }}
            </div>
            <a
              :href="selectWorkUrl"
              ><img
                class="change-work"
                :src="$anm22.icons.getWorldIcon('menuSwitch')"
            /></a>
          </div>
          <div v-else class="wg-row list-owner">
            <img
              :src="$anm22.icons.getWorldIcon('userMaterial')"
              class="image"
            />
            <div class="name">
              {{ $anm22.strLang(lang, "Personal", "Personale") }}
            </div>
            <a
              :href="selectWorkUrl"
              ><img
                class="change-work"
                :src="$anm22.icons.getWorldIcon('menuSwitch')"
            /></a>
          </div>
          <div
            v-if="contacts.length === 0 && filters.length === 0"
            class="com-anm22-app-text-xl"
          >
            <img
              :src="$anm22.icons.getWorldIcon('menuContacts')"
              style="width:60px;display:block;margin:20px auto;opacity:0.3"
            />
            <div
              style="
                text-align: center;
                max-width: 400px;
                font-size: 16px;
                color: #666;
                margin: 0 auto;
              "
            >
              {{ $anm22.strLang(lang, "No contacts ", "Nessun contatto") }}
            </div>
            <div
              style="
                text-align: center;
                max-width: 400px;
                font-size: 14px;
                color: #999;
                margin: 0 auto 50px auto;
              "
            >
              {{
                $anm22.strLang(
                  lang,
                  "Create your first contact",
                  "Crea il tuo primo contatto"
                )
              }}
            </div>
          </div>
          <!-- Contacts list -->
          <router-link
            :to="'/contact/' + (contact.idContactsContact)"
            v-else
            v-for="(contact, index) in contactsList.slice(0,contactsListLimit)"
            :ref="'contact-' + contact.idContactsContact"
            :key="'full-contact-' + index"
          >
            <div
              :class="[
                'wg-row',
                'item ',
                'selectable',
                reminderClass(contact),
                contactId == contact.idContactsContact ? 'selected' : '',
                contact.lastOpen < contact.lastFeedUpdate ? 'to-read' : '',
              ]"
            >
              <div class="container">
                <img
                  :src="
                    contact.type == 2
                      ? $anm22.getObjIcon(contact, 'workMaterial')
                      : $anm22.getContactIcon(contact, $store)
                  "
                  class="image"
                />
              </div>
              <div class="wg-row">
                <div class="wg-row name">
                  {{ $anm22.getContactName(contact, $store) }}
                  <span v-if="contact.type == 2 && $anm22.getReferrerFlag(contact, $store) == 0">{{ $anm22.getContactReferrerName(contact, $store) }}</span>
                  <img
                    v-if="!isSynchronized(contact.idContactsContact)"
                    class="com-anm22-app-img-fixed-height-s"
                    :src="$anm22.icons.getWorldIcon('offline')"
                    style="margin-left: 5px"
                    :title="
                      $anm22.strLang(
                        lang,
                        'Not synchronized',
                        'Non sincronizzato'
                      )
                    "
                  />
                </div>
                <div
                  class="label status"
                  v-if="contact.status"
                  :style="{
                    borderLeft:
                      $store.getters['contactsStatus/get'](contact.status)
                        .color != ''
                        ? '3px solid' +
                          ' ' +
                          $store.getters['contactsStatus/get'](contact.status)
                            .color
                        : '',
                  }"
                >
                  {{ $store.getters["contactsStatus/get"](contact.status).name }}
                </div>
                <div class="label contact">
                  {{
                    contact.workOwner
                      ? ($store.getters["works/get"](contact.workOwner)?$store.getters["works/get"](contact.workOwner).name:'Not found')
                      : $anm22.strLang(lang, "Personal", "Personale")
                  }}
                </div>
              </div>
            </div>
          </router-link>
          <div class="vertical-height-div" style="height: 47px"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Spinner from "vue-simple-spinner";
import Contact from "../Contact.vue";

export default {
  props: {
    contacts: Array,
    filters: Array,
    view: String,
    reminderClass: Function,
    loading: {
      type: Boolean,
      default: true
    },
    sortingModalStatus: {
      type: Boolean,
      default: false
    },
    newContactModalStatus: {
      type: Boolean,
      default: false
    }
  },
  components: {
    "vue-simple-spinner": Spinner,
    Contact,
  },
  data() {
    return {
      orderingContactsField:
        this.$anm22.getCookie("contacts_cols_ordering") !== ""
          ? this.$anm22.getCookie("contacts_cols_ordering")
          : "lastFeedUpdate",
      orderingContactsDir:
        this.$anm22.getCookie("contacts_dir_ordering") !== ""
          ? this.$anm22.getCookie("contacts_dir_ordering")
          : "DESC",
      contactsListLimit: 50,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
      windowWidth: (state) => state.windowWidth,
      workSelected: (state) => state.workSelected,
    }),
    contactsList() {
      return this.contacts.sort(this.sortContacts(this.orderingContactsField, this.orderingContactsDir));
    },
    orderingContactsFields() {
      return [
        {
          field: "lastFeedUpdate",
          label: this.$anm22.strLang(
            this.lang,
            "Last update",
            "Ultimo aggiornamento"
          ),
        },
        {
          field: "fullName",
          label: this.$anm22.strLang(
            this.lang,
            "Name",
            "Nome"
          ),
        },
      ];
    },
    contactId() {
      return this.$store.getters["getContactSelected"];
    },
    selectWorkUrl() {
      return (process.env.NODE_ENV === 'production' ? 'https://www.anm22.it' : process.env.VUE_APP_FRONT_DOMAIN) + '/app/work/selectWork?nullOption=1&cbSucc=..%2Fcontacts-v%2F';
    },
  },
  methods: {
    openContact(id) {
      this.$router.push({ path: `/contact/${id}` });
    },
    resetContact() {
      this.$store.dispatch("selectContact", null);
      document.title = "ANM22 Contacts";
    },
    selectContact(contactId) {
      if (this.$store.getters["contacts/get"](contactId)) {
        if (contactId === this.contactId) {
          this.resetContact();
        } else {
          this.$store.dispatch("selectContact", contactId);
        }
      }
    },
    isSynchronized(id) {
      return this.$store.getters["offline/isSynchronized"](
        this.$anm22.MD5("ContactsContact" + id)
      );
    },
    sortContacts(field, direction) {
      return (a, b) => {
        let aProp;
        let bProp;
        switch(field) {
          case 'fullName':
            aProp = (a['firstName'] + ' ' + a['lastName']).trim();
            bProp = (b['firstName'] + ' ' + b['lastName']).trim();
            break;
          default:
            aProp = a[field];
            bProp = b[field];
        }
        if (aProp > bProp) {
          return direction === 'ASC' ? 1 : -1;
        }
        if (aProp < bProp) {
          return direction === 'ASC' ? -1 : 1;
        }
        return 0;
      };
    },
    changeSortingField(field) {
      this.orderingContactsField = field;
      this.$anm22.setCookie("contacts_cols_ordering", field, 31536000);
    },
    changeSortingDir(dir) {
      this.orderingContactsDir = dir;
      this.$anm22.setCookie("contacts_dir_ordering", dir, 31536000);
    },
    filterNoProjects() {
      this.$anm22.eventBus.$emit('contacts-filter', {
        name: this.$anm22.strLang(this.lang, 'No projects', 'Nessun progetto'),
        fn: c => {
          const projects = this.$store.getters["projects/getByCustomer"](
            c.idContactsContact
          );
          return !projects || projects.length == 0;
        }
      });
    },
    getNextContacts() {
      document.getElementById('contacts-div').onscroll = () => {
        let bottomOfList = document.getElementById('contacts-div').scrollTop + document.getElementById('contacts-div').clientHeight >= this.contactsListLimit * 61;
        if (bottomOfList) {
          this.contactsListLimit += 20;
          console.log("Loading next contacts...")
        }
      }
    },
    checkListLimitAfterResize() {
      window.addEventListener('resize', (event) => {
        if (window.innerHeight / 61 >= this.contactsListLimit) {
          this.contactsListLimit = Math.round(window.innerHeight / 61);
          console.log("Resized kanbann to " + this.contactsListLimit + " items");
        }
      }, true);
    },
    openSortingModal() {
      this.$emit('changeSortingModalStatus', true);
    },
    closeSortingModal() {
      this.$emit('changeSortingModalStatus', false);
    },
    openNewContactModal() {
      this.$emit('changeNewContactModalStatus', true);
    },
    closeNewContactModal() {
      this.$emit('changeNewContactModalStatus', false);
    },
  },
  created() {
    if (window.innerHeight / 61 >= this.contactsListLimit) {
      this.contactsListLimit = Math.round(window.innerHeight / 61);
      console.log("Resized list to " + this.contactsListLimit + " items");
    }
  },
  mounted() {
    this.getNextContacts();
    this.checkListLimitAfterResize();
  },
  watch: {
    contactId(newVal, oldVal) {
      if(this.$refs["contact-" + newVal]) {
        this.$refs["contact-" + newVal][0].scrollIntoView();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.contacts-bar {
  flex-wrap: nowrap;
  align-items: center;
  height: 60px;
  border-bottom: 1px solid #eee;
  padding: 10px;
  overflow: hidden;
  background: #fff;
  position:relative;
}
@media (min-width: 992px) {
  .contacts-bar {
    display: none;
  }
}
.contacts-list {
  border-right: 1px solid #eee;
  height: calc(100vh - 120px);
  overflow-x: hidden;

  &.resize {
    transition: height 0.2s linear;
    height:calc(100vh - 60px);
  }

  .list-owner {
    flex-wrap: nowrap;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding: 10px;
    position: relative;

    .image {
      width: 20px;
      height: 20px;
      border: 1px solid #eee;
      border-radius: 12px;
      margin-right: 8px;
      display: inline-block;
      vertical-align: middle;
    }
    .name {
      display: inline-block;
      font-weight: 500;
    }
    .change-work {
      width: 20px;
      height: 20px;
      margin-left: 8px;
      display: inline-block;
      vertical-align: middle;
    }
  }

  .item {
    flex-wrap: nowrap;
    align-items: center;
    min-height: 60px;
    border-bottom: 1px solid #ddd;
    padding: 10px;
    position: relative;
    &.selectable {
      cursor: pointer;
    }
    &.selectable:hover {
      background: #eee;
    }
    &.selectable.selected {
      background: #eee;
      border-right: 2px solid rgb(10, 171, 244);
    }
    
    .image {
      width: 40px;
      height: 40px;
      border: 1px solid #eee;
      border-radius: 20px;
      margin-right: 5px;
      //box-sizing:content-box;
    }
    &.blue .image {
      border: 2px solid #eee;
      border-color: #007fff!important ;
      border-image-width: 2px;
    }
    &.yellow .image {
      border: 2px solid #eee;
      border-color: #F6BE00!important;
      border-image-width: 2px;
    }
    &.red .image {
      border: 2px solid #eee;
      border-color: #f00!important ;
      border-image-width: 2px;
    }
    &.to-read .image {
      border: 2px solid #eee;
      border-color: grey;
      border-image-width: 2px;
    }

    .name {
      margin-bottom: 4px;
    }
    &.to-read .name {
      font-weight: bold;
    }
    .label {
      border-radius: 4px;
      background-color: #eee;
      font-size: 12px;
      color: #666;
      display: inline-block;
      padding: 2px 4px;

      &.customer {
        border-left: 3px solid #88ed7c;
        padding-right: 7px;
      }
      &.contact {
        border-left: 3px solid #0aabf4;
        padding-right: 7px;
      }
      &.ticket {
        border-left: 3px solid #cccccc;
        padding-right: 7px;
      }
      &.social {
        border-left: 3px solid #f40a93;
        padding-right: 7px;
      }
      &.status {
        padding-right: 7px;
        margin-right: 5px;
      }
    }
  }
}
@media (min-width: 992px) {
  .contacts-list {
    height: calc(100vh - 60px);
  }
}
.filter-button {
  flex-wrap: nowrap;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background-color: #ddd;
  border-radius: 5px;
  padding: 10px;
  margin: 0 5px;
}
.change-view, .sort-modal {
  opacity:0.6;
  width:25px;
  // position:absolute;
  cursor:pointer;
}
.views-list {
  text-align: center;

  .item {
    text-align: center;
    display: inline-block;
    vertical-align: top;
    width: 150px;
    margin: 5px;
    border-radius: 6px;
    cursor: pointer;
    padding: 10px 0 15px 0;

    img {
      display: inline-block;
      height: 60px;
      opacity: 0.6;
    }
    div {
      text-align: center;
      display: block;
      font-size: 16px;
    }
  }
  .item:hover,
  .item.selected {
    background: #eee;
  }
}
.cont {
  position: relative;
  font-weight: normal;
  min-height: 15px;
  padding: 6px;
  border-radius: 10px;
  cursor: pointer;
}
.cont:hover {
  background-color: #eee;
}
.cont-tick {
  margin-left: auto;
}
.wg-row .name span{
  margin-left: 2%;
}
</style>

